/* import __COLOCATED_TEMPLATE__ from './fly-table-sort-header.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
/**
  ```hbs
  <FlyTableSortHeader
    class="p-0"
    \@innerClasses="pl-3 py-2"
    \@value="name"
    \@label="Name"
    \@sortBy={{this.sortBy}}
    \@sortDisabled={{false}}
    \@sortDirection={{this.sortDirection}}
    \@onSort={{this.onSort}}
  />
  ```

  @class FlyTableSortHeader
  @public
*/
let FlyTableSortHeader = (_class = class FlyTableSortHeader extends Component {
  get defaultSortDirection() {
    return this.args.defaultSortDirection ?? 'desc';
  }
  get isCurrent() {
    return this.args.value === this.args.sortBy;
  }
  get icon() {
    let sortDirection = this.isCurrent ? this.args.sortDirection : this.defaultSortDirection;
    return sortDirection === 'asc' ? 'chevron-up' : 'chevron-down';
  }
  get sortDisabled() {
    return this.args.sortDisabled ?? false;
  }
  onSortClick() {
    if (this.isCurrent) {
      let direction = this.args.sortDirection === 'asc' ? 'desc' : 'asc';
      return this.args.onSort(this.args.value, direction);
    }
    return this.args.onSort(this.args.value, this.defaultSortDirection);
  }
}, (_applyDecoratedDescriptor(_class.prototype, "onSortClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSortClick"), _class.prototype)), _class);
export { FlyTableSortHeader as default };